export default "/images/vendor/flag-icon-css/flags/1x1/be.svg?5b3a82a296b071e1440a4b997dd4c391";